import React, { FC } from 'react';
import { Button, Box as Wrapper, Text } from '@tonic-ui/react';
import { Modal } from '../../components/modal';
import { useTranslation } from 'react-i18next';

interface TemplateScannerDismissModal {
  submitModal: () => void;
  onClose: () => void;
  isOpen: boolean;
}

const TemplateScannerDismissModal: FC<TemplateScannerDismissModal> = ({
  submitModal,
  onClose,
  isOpen,
}) => {
  const { t } = useTranslation();

  const returnToAccountSelection = (_) => submitModal();

  return (
    <Modal
      id="template-scanner-dismiss"
      isOpen={isOpen}
      onClose={onClose}
      closeOnOutsideClick={false}
      size="sm"
      header={t('templateScannerModal.title')}
      body={
        <Wrapper mt="13px">
          <Text size="sm" lineHeight="sm" mb="15px">
            {t(`templateScannerModal.description.first`)}
          </Text>
          <Text size="sm" lineHeight="sm" mb="15px">
            {t(`templateScannerModal.description.second`)}
          </Text>
          <Text size="sm" lineHeight="sm">
            {t(`templateScannerModal.description.third`)}
          </Text>
        </Wrapper>
      }
      footer={
        <>
          <Button variant="primary" minWidth={64} onClick={returnToAccountSelection}>
            {t('templateScannerModal.button.primary')}
          </Button>
          <Button width="fit-content" marginLeft={23} onClick={onClose}>
            {t('templateScannerModal.button.secondary')}
          </Button>
        </>
      }
    />
  );
};

TemplateScannerDismissModal.displayName = 'TemplateScannerDismissModal';
export default TemplateScannerDismissModal;
